/**
 * LR HUB special badges — Founder / Founding Member (and future team/official).
 *
 * ISOLATION: Hub-only. The badge value lives on `hub_settings.hub_badge` and is
 * ADMIN-ASSIGNABLE ONLY (enforced by the `hub_settings_guard` DB trigger — a
 * member's own update can never change it). It is read LIVE through
 * `hub_display_identities`, exactly like role visibility.
 */

export type HubBadge = "founder" | "founding_member" | "team" | "official";

export interface HubBadgeStyle {
  label: string;
  /** Tailwind classes for the pill. */
  className: string;
  title: string;
}

export const HUB_BADGES: Record<HubBadge, HubBadgeStyle> = {
  founder: {
    label: "Founder",
    // Gold treatment — the single most distinct badge on the Hub.
    className:
      "border border-amber-400/70 bg-gradient-to-r from-amber-100 to-amber-50 text-amber-800 shadow-[0_0_0_1px_rgba(251,191,36,0.25)]",
    title: "LaneRunner Founder",
  },
  founding_member: {
    label: "Founding Member",
    className: "border border-brand-teal-deep/30 bg-brand-teal-subtle text-brand-teal-deep",
    title: "Founding member of the LR Hub",
  },
  team: {
    label: "LR Team",
    className: "border border-brand-teal-deep/30 bg-brand-teal-subtle text-brand-teal-deep",
    title: "LaneRunner team member",
  },
  official: {
    label: "Official",
    className: "border border-brand-teal-deep/40 bg-brand-teal-subtle text-brand-teal-deep",
    title: "Official LaneRunner account",
  },
};

export function hubBadgeStyle(badge?: string | null): HubBadgeStyle | null {
  if (!badge) return null;
  return HUB_BADGES[badge as HubBadge] ?? null;
}

/** The Founder replaces the role pill (Tim isn't a shipper/broker/carrier). */
export function hubBadgeReplacesRole(badge?: string | null): boolean {
  return badge === "founder" || badge === "team" || badge === "official";
}
